import { initVkPixel } from '@/shared/lib/vkPixel';

export default defineNuxtPlugin({
  name: 'vkPixel',
  setup: (nuxtApp) => {
    nuxtApp.hook('app:suspense:resolve', () => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(() => initVkPixel());
        return;
      }
      setTimeout(initVkPixel);
    });
  },
});
